module.exports = __webpack_public_path__ + "static/media/Information.33f7f3c7.svg";